export default {
    show: (data) => window.axios.post('couponlisting', data),
    couponRedeem: (data) => window.axios.post('coupon_redeem', data),
    getPromoCodes: (data) => window.axios.post('chowman_pay/promocodes', data),
    getRedeemPromocode: (data) => window.axios.post('chowman_pay/redeem_coupon', data),
    giftVoucherList: (data) => window.axios.post('gift-voucher-list', data),
    giftVoucherSelect: (data) => window.axios.post('gift-voucher-select', data),
    giftVoucherRedeem: (data) => window.axios.post('gift-voucher-redeem', data),
    giftVoucherHistory: (data) => window.axios.post('gift-voucher-history', data),

}